import { defaultMonthOptions } from './_defaults';
import { BsDatepickerConfig } from '../bs-datepicker.config';
var BsDatepickerState = (function () {
    function BsDatepickerState() {
    }
    return BsDatepickerState;
}());
export { BsDatepickerState };
export var initialDatepickerState = Object.assign(new BsDatepickerConfig(), {
    view: { date: new Date(), mode: 'day' },
    selectedRange: [],
    monthViewOptions: defaultMonthOptions
});
//# sourceMappingURL=bs-datepicker.state.js.map


//////////////////
// WEBPACK FOOTER
// C:/Agent0/_work/434/s/~/ngx-bootstrap/datepicker/reducer/bs-datepicker.state.js
// module id = ../../../../ngx-bootstrap/datepicker/reducer/bs-datepicker.state.js
// module chunks = 3